<template>
  <div class="flex h-full w-full items-center justify-center text-center">
    <div class="flex w-[600px] flex-col items-center gap-6">
      <div v-if="hasIllustration" class="max-w-[413px]">
        <slot name="illustration" />
      </div>
      <div v-if="hasTitle || hasDescription" class="flex flex-col gap-2">
        <h2 v-if="hasTitle" class="text-[26px] font-medium">
          <slot name="title">
            {{ title }}
          </slot>
        </h2>
        <p v-if="hasDescription" class="text-base font-normal">
          <slot name="description">
            {{ description }}
          </slot>
        </p>
      </div>
      <div v-if="hasActions">
        <slot name="actions" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      title?: string;
      description?: string;
    }>(),
    {
      title: "No data available",
      description: "We could not find any data",
    }
  );

  const slots = useSlots();

  const hasTitle = computed(() => slots.title !== undefined || props.title !== "");
  const hasDescription = computed(() => slots.description !== undefined || props.description !== "");
  const hasIllustration = computed(() => slots.illustration !== undefined);
  const hasActions = computed(() => slots.actions !== undefined);
</script>
